import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Button, Grid2, Paper } from "@mui/material";
import FullScreenModal from "components/common/FullScreenModal";
import SettingsTagForm from "components/settings/tags/SettingsTagForm";
import SettingsTagListItem from "components/settings/tags/SettingsTagListItem";
import { actions } from "components/settings/tags/logic/actions";
import log from "loglevel";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./styles.scss";

const SettingsTagList = ({ getReviewTags, reviewTags }) => {
    const [openForm, setOpenForm] = useState(false);

    useEffect(() => {
        getReviewTags({
            isDeleted: "NOT_DELETED",
        });
    }, [getReviewTags]);

    log.debug("reviewTags", reviewTags);

    return (
        (<Grid2
            className="settings-tag-list"
            container
            spacing={2}
            style={{ position: "relative", height: "85vh", display: "block" }}
        >
            <FullScreenModal title={"Add New Tag"} handleClose={() => setOpenForm(false)} open={openForm}>
                <Grid2 size={12}>
                    <SettingsTagForm />
                </Grid2>
            </FullScreenModal>
            <Grid2 size={12}>
                <Paper>
                    <div className="toolbar" style={{ display: "flex", flex: 1 }}>
                        <Button
                            size={"small"}
                            variant={"outlined"}
                            startIcon={<AddIcon />}
                            onClick={() => setOpenForm(true)}
                        >
                            Add Tag
                        </Button>
                        <Button size={"small"} variant={"outlined"} startIcon={<RefreshIcon />}>
                            Refresh
                        </Button>
                    </div>
                    <div style={{ display: "block", maxHeight: "calc(100vh - 180px)", overflowY: "auto" }}>
                        {reviewTags.map((tag) => (
                            <Grid2 className="stripe-row" key={tag.id} item size={12}>
                                <SettingsTagListItem {...tag} />
                            </Grid2>
                        ))}
                    </div>
                </Paper>
            </Grid2>
        </Grid2>)
    );
};

const mapStateToProps = ({ tagSettings }) => ({
    reviewTags: tagSettings.reviewTags,
    test: tagSettings.test,
});

const mapDispatchToProps = (dispatch) => ({
    getReviewTags: (query) => dispatch(actions.GET_REVIEW_TAGS.send(query)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsTagList);
